module.exports = __webpack_public_path__ + "img/icon-lock.4a0a7911.svg";